var exports = {
  "C": "noBorderRadius__7KSzwA",
};

module.exports = exports;
